// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"OZ-z","categoryName":"PZ-z","categoryImage":"QZ-z","categoryContent":"RZ-z","bottomAligned":"SZ-z"};